import { createSelector } from 'reselect';
import { RootState } from 'src/app/store';
import { MovementState } from './movementStore';

const getState = (state: RootState): MovementState => state.movements;
export const getUnassignedMovements = createSelector(
  getState,
  (state: MovementState) => state.Unassigned || [],
);

export const getProposedMovements = createSelector(
  getState,
  (state: MovementState) => state.Proposed || [],
);
